"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ApiManager_1 = require("../ApiManager");
var ApiConfig_1 = require("../config/ApiConfig");
var ApiToken = /** @class */ (function (_super) {
    __extends(ApiToken, _super);
    function ApiToken() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.V2_REVOKE_TOKEN = '/auth/revokeToken';
        _this.getReloadToken = function (token, revokeToken) {
            var data = {
                token: token,
                revokeToken: revokeToken,
            };
            return ApiConfig_1.Axios.Client({
                header: {},
                method: 'post',
                url: _this.V2_REVOKE_TOKEN,
                data: data,
            });
        };
        return _this;
    }
    ApiToken.getInstance = function (initValue) {
        if (!ApiToken.classInstance) {
            this.classInstance = new ApiToken(initValue);
        }
        return this.classInstance;
    };
    return ApiToken;
}(ApiManager_1.ApiManager));
exports.default = ApiToken;
